import {FileResponseBody, UuidResponseBody, Money} from '@dms/api/shared';

export type GetVehicleWarehouseManagementSettingsApiResponse =
  /** status 200  */ VehicleWarehouseManagementSettingsResponseBody;
export type EnableVehicleWarehouseManagementApiResponse = unknown;
export type DisableVehicleWarehouseManagementApiResponse = unknown;

export type CreateVehicleWarehouseApiResponse =
  /** status 201  */ VehicleWarehouseCreatedResponseBody;
export type CreateVehicleWarehouseApiArg = {
  body: CreateVehicleWarehouseRequestBody;
};
export type GetVehicleWarehouseApiResponse = /** status 200  */ VehicleWarehouseResponseBody;
export type GetVehicleWarehouseApiArg = {
  vehicleWarehouseId: string;
};
export type PatchVehicleWarehouseApiResponse = unknown;
export type PatchVehicleWarehouseApiArg = {
  vehicleWarehouseId: string;
  body: PatchVehicleWarehouseRequestBody;
};
export type DeleteVehicleWarehouseApiResponse = unknown;
export type DeleteVehicleWarehouseApiArg = {
  vehicleWarehouseId: string;
};
export type GetUserVehicleWarehousesApiResponse =
  /** status 200  */ UserVehicleWarehouseResponseBody[];
export type IssueVehicleWarehouseMovementApiResponse = /** status 201  */ UuidResponseBody;
export type IssueVehicleWarehouseMovementApiArg = {
  vehicleWarehouseId: string;
  body: IssueVehicleToVehicleWarehouseRequestBody;
};
export type ReceiveVehicleWarehouseMovementApiResponse = /** status 201  */ UuidResponseBody;
export type ReceiveVehicleWarehouseMovementApiArg = {
  vehicleWarehouseId: string;
  body: ReceiveVehicleToVehicleWarehouseRequestBody;
};
export type GetVehicleWarehouseMovementApiResponse =
  /** status 200  */ VehicleWarehouseMovementResponseBody;
export type GetVehicleWarehouseMovementApiArg = {
  vehicleWarehouseMovementId: string;
};
export type GetSaleVehicleWarehouseInformationApiResponse =
  /** status 200  */ SaleVehicleWarehouseInformationResponseBody;
export type GetSaleVehicleWarehouseInformationApiArg = {
  vehicleId: string;
  saleVehicleId: string;
};
export type GetSaleVehicleAvailableWarehouseActionsApiResponse =
  /** status 200  */ SaleVehicleAvailableWarehouseActionsResponseBody;
export type GetSaleVehicleAvailableWarehouseActionsApiArg = {
  vehicleId: string;
};
export type CancelIssueVehicleWarehouseMovementApiResponse = /** status 201  */ UuidResponseBody;
export type CancelIssueVehicleWarehouseMovementApiArg = {
  vehicleId: string;
  saleVehicleId: string;
  body: CancelIssueVehicleToVehicleWarehouseRequestBody;
};
export type CancelReceiptVehicleWarehouseMovementApiResponse = /** status 201  */ UuidResponseBody;
export type CancelReceiptVehicleWarehouseMovementApiArg = {
  vehicleId: string;
  saleVehicleId: string;
  body: CancelReceiveVehicleToVehicleWarehouseRequestBody;
};
export type TransferVehicleWarehouseMovementApiResponse =
  /** status 201  */ TransferVehicleToVehicleWarehouseResponseBody;
export type TransferVehicleWarehouseMovementApiArg = {
  vehicleId: string;
  saleVehicleId: string;
  body: TransferVehicleToVehicleWarehouseRequestBody;
};
export type PatchSaleVehicleStockInDateApiResponse = unknown;
export type PatchSaleVehicleStockInDateApiArg = {
  vehicleId: string;
  patchSaleVehicleStockInDateRequestBody: PatchSaleVehicleStockInDateRequestBody;
};
export type PatchSaleVehicleStockInDateRequestBody = {
  stockInDate: string;
};
export type GetVehicleInWarehouseHistorySummaryApiArg = {
  body: GetVehicleInWarehouseHistorySummaryApiRequestBody;
};
export type GetVehicleInWarehouseHistorySummaryApiResponse =
  /** status 201  */ GetVehicleInWarehouseHistorySummaryApiResponseBody;
export type GetVehicleInWarehouseHistorySummaryApiRequestBody = {
  vehicleWarehouseIds: string[];
  date: string;
};
export type GetUserVehicleWarehousesForVehicleApiResponse =
  /** status 200  */ UserVehicleWarehouseResponseBody[];
export type GetUserVehicleWarehousesForVehicleApiArg = {
  vehicleId: string;
};
export type ListVehicleWarehousesApiResponse =
  /** status 200  */ ListVehicleWarehouseResponseBody[];
export type ListVehicleWarehousesApiArg = {
  branchId?: string;
};
export type ListVehicleWarehouseResponseBody = {
  id: string;
  name: string;
};
export type GetVehicleInWarehouseHistorySummaryApiResponseBody = {
  value: Money;
  count: number;
  saleValue: Money;
  saleValueWithoutVat: Money;
};
export type VehicleWarehouseManagementSettingsResponseBody = {
  isEnabled: boolean;
};
export type VehicleWarehouseCreatedResponseBody = {
  id: string;
};
export type CreateVehicleWarehouseRequestBody = {
  name: string;
  customId: string;
  costCentre: string | null;
  companyId: string;
  branchIds: string[];
  receivingSeriesId: string;
  issuingSeriesId: string;
  serialNumberSeriesId: string;
  correctiveTaxDocumentSeriesId: string | null;
  invoiceSeriesId: string | null;
  proformaInvoiceSeriesId: string | null;
  taxDocumentSeriesId: string | null;
  overrideBusinessCaseSeries: boolean;
};
export type VehicleWarehouseResponseBody = {
  id: string;
  name: string;
  customId: string;
  costCentre: string | null;
  companyId: string;
  branchIds: string[];
  receivingSeriesId: string;
  issuingSeriesId: string;
  serialNumberSeriesId: string;
  createdBy: string;
  createdAt: string;
  correctiveTaxDocumentSeriesId: string | null;
  invoiceSeriesId: string | null;
  proformaInvoiceSeriesId: string | null;
  taxDocumentSeriesId: string | null;
  overrideBusinessCaseSeries: boolean;
};
export type PatchVehicleWarehouseRequestBody = {
  name: string;
  customId: string;
  costCentre: string | null;
  branchIds: string[];
  overrideBusinessCaseSeries: boolean;
  proformaInvoiceSeriesId: string | null;
  receivingSeriesId: string | null;
  serialNumberSeriesId: string | null;
  taxDocumentSeriesId: string | null;
};
export type UserVehicleWarehouseResponseBody = {
  id: string;
  name: string;
  branchIds: string[];
};
export type IssueVehicleToVehicleWarehouseRequestBody = {
  vehicleId: string;
  movementAt: string;
  issueTemplateId?: string | null;
  note?: string | null;
};
export type ReceiveVehicleToVehicleWarehouseRequestBody = {
  vehicleId: string;
  movementAt: string;
  receiptTemplateId?: string | null;
  note?: string | null;
  supplierInvoiceNumber?: string | null;
};
export type VehicleWarehouseMovementResponseBody = {
  id: string;
  type: string;
  code: string;
  serialNumber: string;
  saleVehicleId: string;
  vehicleWarehouseId: string;
  businessCaseId: string;
  document: FileResponseBody | null;
  createdBy: string;
  createdAt: string;
  supplierInvoiceNumber: string | null;
};
export type SaleVehicleWarehouseInformationResponseBody = {
  warehouse: string | null;
  stockKeepingUnit: string | null;
  receivedAt: string | null;
  receivedBy: string | null;
  issuedAt: string | null;
  issuedBy: string | null;
  supplierInvoiceNumber: string | null;
};
export type SaleVehicleAvailableWarehouseActionsResponseBody = {
  receive: boolean;
  transfer: boolean;
  issue: boolean;
  cancelReceipt: boolean;
  cancelIssue: boolean;
};
export type CancelIssueVehicleToVehicleWarehouseRequestBody = {
  cancellationDate?: string | null;
  issueCancellationTemplateId?: string | null;
  note?: string | null;
};
export type CancelReceiveVehicleToVehicleWarehouseRequestBody = {
  cancellationDate?: string | null;
  receiptCancellationTemplateId?: string | null;
  note?: string | null;
};
export type TransferVehicleToVehicleWarehouseResponseBody = {
  receiptMovementId: string;
  issueMovementId: string;
};
export type TransferVehicleToVehicleWarehouseRequestBody = {
  toVehicleWarehouseId: string;
  movementAt: string;
  receiptTemplateId?: string | null;
  issueTemplateId?: string | null;
  note?: string | null;
};
export type ListAvailableVehicleWarehousesForVehicleMovementApiResponse =
  /** status 200  */ VehicleWarehouseForVehicleMovementResponseBody[];
export type VehicleWarehouseForVehicleMovementResponseBody = {
  id: string;
  name: string;
  branchIds: string[];
};
export type ReReceiveVehicleToVehicleWarehouseResponseBody = {
  receiptCancelMovementId: string;
  receiptMovementId: string;
};
export type ReReceiveVehicleToVehicleWarehouseRequestBody = {
  vehicleWarehouseId: string;
  receiveDate: string;
  receiptCancelTemplateId?: string | null;
  receiptTemplateId?: string | null;
  note?: string | null;
  supplierInvoiceNumber?: string | null;
};
export type ListAvailableVehicleWarehousesForVehicleMovementApiArg = {
  vehicleId?: string;
};
export type ReReceiveVehicleToVehicleWarehouseApiResponse =
  /** status 200  */ ReReceiveVehicleToVehicleWarehouseResponseBody;
export type ReReceiveVehicleToVehicleWarehouseApiArg = {
  vehicleId: string;
  reReceiveVehicleToVehicleWarehouseRequestBody: ReReceiveVehicleToVehicleWarehouseRequestBody;
};
